// Color System for Customer Web App (matching Marketplace design)

// Marketplace Theme Colors (matching frontend/marketplace)
export const marketplaceColors = {
  // Primary Blue (referred to as "gold" in original but actually blue)
  gold: {
    primary: '#0066FF',     // Main primary blue
    light: '#4D94FF',       // Light blue
    dark: '#0052CC',        // Dark blue
    paleGold: '#E6F2FF',    // Pale blue background
  },

  // Neutral Grays
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

  // Text Colors
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.7)',
    dark: '#333',
    darkGray: '#666',
  },

  // Status Colors
  status: {
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',
  },
};

// Common UI Colors
export const commonColors = {
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',

  // Gray Scale
  gray: {
    25: '#f8f9fa',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#f2f2f2',
    300: '#e0e0e0',
    400: '#ccc',
    500: '#999',
    600: '#666',
    700: '#333',
    800: '#2c2c2c',
    900: '#1a1a1a',
  },
};

// Gradients
export const gradients = {
  marketplace: {
    luxuryBlue: `linear-gradient(135deg, ${marketplaceColors.gold.primary} 0%, ${marketplaceColors.gold.dark} 100%)`,
    cardOverlay: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.6) 25%, rgba(0,0,0,0.05) 70%)',
    headerGradient: 'linear-gradient(135deg, #2e5ec3 0%, #1e3a8a 100%)',
  },
};

// Border Radius Presets
export const borderRadius = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '9999px',
};

// Default export
const themeColors = {
  marketplace: marketplaceColors,
  common: commonColors,
  gradients,
  borderRadius,
};

export default themeColors;
